import HttpService from "./htttp.service";

class AgentsService {
  getAgents = async (page, pageSize, sortColumn, sortColumnValue, searchValue) => {
    let fetchUrl = "agents";
    if (page && pageSize && sortColumn && sortColumnValue) {
      fetchUrl = `agents?page=${page}&per_page=${pageSize}&sort_column=${
        sortColumn
      }&sort_column_value=${sortColumnValue}&search_value=${encodeURIComponent(searchValue)}`;
    }
    return await HttpService.get(fetchUrl);
  };

  addAgent = async (newAgent) => {
    const fetchUrl = "agents";
    return await HttpService.post(fetchUrl, newAgent);
  };

  updateAgent = async (id, data) => {
    const fetchUrl = `agents/${id}`;
    return await HttpService.put(fetchUrl, data);
  };

  updateActiveAgent = async (id, data) => {
    const fetchUrl = `agents/${id}`;
    return await HttpService.patch(fetchUrl, data);
  };

  showAgent = async (id) => {
    const fetchUrl = `agents/${id}`;
    return await HttpService.get(fetchUrl);
  };

  deleteAgent = async (id) => {
    const fetchUrl = `agents/${id}`;
    return await HttpService.delete(fetchUrl);
  };
}

export default new AgentsService();
